module.exports = __webpack_public_path__ + "322ac39a90604854089b987f2091a398.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/games/Dawn-of-War-II.jpg
// module id = 269
// module chunks = 0